'use client'
import React from 'react';
import { Link } from "@/navigation";
import { useTranslations } from 'next-intl';
import moment from 'moment';
import CustomImage from '../Image';

interface RecentPostsProps {
	blogList: any[];
}

const RecentPosts: React.FC<RecentPostsProps> = ({ blogList }) => {
	const t = useTranslations();
	
	return (
		<div className="overflow-hidden border border-gray-200 bg-white shadow-md md:mt-10 mt-6">
			<div className="bg-mainColor px-5 py-3">
				<h2 className="text-lg font-bold text-white flex items-center gap-2">
					<i className="ri-time-line text-lg"></i>
					{t('blog.recentPosts')}
				</h2>
			</div>
			<div className="p-4">
			<div className="flex flex-col gap-5">
				{blogList.slice(0, 6).map((item, index) => (
					<Link 
						href={`/blog/${item.blog_slug}`} 
						className="flex gap-4 cursor-pointer group hover:opacity-90 transition-all hover:border-mainColor border p-1 rounded-md" 
						key={item.blog_slug}
					>
						<CustomImage
							src={item.blog_cover_origin}
							width={64}
							height={64}
							alt={item.blog_title}
							className="w-16 h-16 object-cover rounded flex-shrink-0 shadow-sm group-hover:shadow-md transition-shadow"
						/>
						<div className="flex-1 min-w-0 py-0.5">
							<div className="text-[14px] font-semibold text-gray-900 line-clamp-1 mb-1 leading-snug group-hover:text-mainColor transition-colors">
								{item.blog_title}
							</div>
							{item.blog_excerpt && (
								<div className="text-xs text-gray-600 line-clamp-1 mb-2 leading-relaxed">
									{item.blog_excerpt}
								</div>
							)}
							<div className="text-xs text-mainColor flex items-center gap-1.5">
								<svg className="w-3 h-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
								</svg>
								{item.blog_upload_time && moment(item.blog_upload_time).format("MMM DD, YYYY")}
							</div>
						</div>
					</Link>
				))}
			</div>
			</div>
		</div>
	);
};

export default RecentPosts;
